import { Container } from "@mantine/core";
import React, { useEffect } from "react";
import useFirebaseAuth from "../../context/useFirebaseAuth";

const UserProfile = () => {
  const { authUser } = useFirebaseAuth();

  useEffect(() => {
    console.log("====================================");
    console.log("logged in user grom profile: ", authUser);
    console.log("====================================");
  }, []);
  return (
    <Container>
      Bonjour {authUser?.firstname}, {authUser?.name}. Vous etes sur votre
      profile
      <br />
      Email: {authUser?.email},
    </Container>
  );
};

export default UserProfile;
